import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EventoListModalModule } from './components/evento-list-modal/evento-list-modal.module';
import { JustificativaModalModule } from './components/justificativa-modal/justificativa-modal.module';
import { CartaCorrecaoModalModule } from './components/carta-correcao-modal/carta-correcao-modal.module';
import { ActionsModalModule } from '../pages/fin/titulo/actions-modal/actions-modal.module';
import { FiltroEstoqueModule } from '../pages/est/estoque/filtro-estoque/filtro-estoque.module';
import { RunModalModule } from './components/run-modal/run-modal.module';
import { ReporteModalModule } from '../pages/ind/ordem-producao/reporte-modal/reporte-modal.module';


@NgModule({
  declarations: [],
  imports: [
	CommonModule,JustificativaModalModule, EventoListModalModule, CartaCorrecaoModalModule, ActionsModalModule, FiltroEstoqueModule, RunModalModule, ReporteModalModule
  ]
})
export class PopupModule { }
